import React from 'react';

function Footer() {
  return (
    <footer className="app-footer">
      <p className="safety-msg">Cada persona de regreso a casa, sana y salva, todos los días.</p>
      <p className="signature">&copy; 2026 Powered by <a href="https://vynex.ar" target="_blank" rel="noopener noreferrer">VYNEX</a></p>
    </footer>
  );
}

export default Footer;
